export default function formatMessage(message: string, metadata: Record<string, string> = {}): string {
    return message.replace(
        /{{([^}]+)}}/g,
        (_, key) => (metadata[key] === undefined ? '' : metadata[key]),
    );
}
